// Where a call's word stands at the table (design 15 §11): never over a river or your hand, and on the screen.

/** A box in the callout layer's pixels. */
export interface Box { l: number; t: number; r: number; b: number }
// The places tried, nearest first: out from the anchor (a seat's wall) or in, in pixels, and along its side, which costs
// a little less (the word stays beside its seat). Far in: on an upright phone a side seat's anchor is at the screen's
// edge, and a word 130 px wide needs 70 px to come back on.
const TRIES: [number, number][] = [];
for (let a = -180; a <= 120; a += 6) for (let p = -320; p <= 320; p += 8) TRIES.push([a, p]);
TRIES.sort((m, n) => Math.abs(m[0]) + 0.75 * Math.abs(m[1]) - (Math.abs(n[0]) + 0.75 * Math.abs(n[1])));

/** Where a callout of this size stands nearest its anchor without covering a box to avoid or leaving the screen
 *  (`room`, in the same pixels): first along the seat's direction, out or in, then along its side. Null: nowhere. */
export function calloutSpot(at: { x: number; y: number; ux: number; uy: number }, w: number, h: number, avoid: Box[], room: Box): { x: number; y: number } | null {
  for (const [a, p] of TRIES) {
    const x = at.x + at.ux * a - at.uy * p;
    const y = at.y + at.uy * a + at.ux * p;
    const l = x - w / 2, t = y - h / 2, r = x + w / 2, b = y + h / 2;
    if (l < room.l || t < room.t || r > room.r || b > room.b) continue;
    if (avoid.some((k) => l < k.r && r > k.l && t < k.b && b > k.t)) continue;
    return { x, y };
  }
  return null;
}
